/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minor_Dirty_Elephant_LeadInputs */

const fr_minor_dirty_elephant_lead = /** @type {(inputs: Minor_Dirty_Elephant_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-in`)
};

/**

* @param {Minor_Dirty_Elephant_LeadInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const minor_dirty_elephant_lead = /** @type {((inputs?: Minor_Dirty_Elephant_LeadInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minor_Dirty_Elephant_LeadInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_minor_dirty_elephant_lead(inputs)
});